/* src/app/forms/painel-correios/cep-consultapreco/cep-consultapreco.component.scss */
.card-model {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.mat-mdc-card-title {
  font-size: 180%;
}
.card-content {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
}
:host {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.cep-fields-grid {
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
}
.key-class {
  font-size: 80%;
  font-weight: 500;
}
.value-class {
  font-size: 80%;
}
.message-class {
  display: flex;
  flex-direction: column;
}
.columns-data {
  width: 33%;
  padding: 2px;
}
.columns-data-detail {
  width: 20%;
  padding: 2px;
  font-size: 80%;
}
.vl {
  border-left: 1px solid gray;
  height: 30px;
  margin-left: 4px;
  margin-right: 4px;
}
.message {
  font-size: 80%;
}
.title-card {
  width: 100%;
  justify-content: space-between;
  display: flex;
  flex-direction: row;
}
mat-form-field {
  width: 100%;
}
.resultado {
  display: flex;
  height: 50%;
  width: 100%;
  overflow: auto;
}
.cep {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
.cep-content {
  display: flex;
  flex-direction: column;
  height: fit-content;
}
.mat-mdc-card-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 30px;
}
ul {
  columns: 2;
  -webkit-columns: 2;
  -moz-columns: 2;
}
/*# sourceMappingURL=cep-consultapreco.component.css.map */
